import { useCallback } from 'react'
import useOnboard, { connectWallet } from '@/hooks/wallets/useOnboard'
import { selectEnvironment } from '@/store/hederaSettingsSlice'
import { useAppSelector } from '@/store'
import { connectHashPack } from '@/hooks/wallets/useHashPack'
import useChainId from '@/hooks/useChainId'

const useConnectWallet = () => {
  const chainId = useChainId()
  const onboard = useOnboard()
  const environment = useAppSelector(selectEnvironment)

  return useCallback(() => {
    if (environment === 'hedera') {
      return connectHashPack(chainId)
    }

    // default logic for evm
    if (!onboard) {
      return Promise.resolve(undefined)
    }

    return connectWallet(onboard)
  }, [onboard, environment, chainId])
}

export default useConnectWallet
